import {
  Component,
  input,
  output,
  signal,
  ViewChild,
  effect,
} from '@angular/core';
import { IonButton, IonIcon, IonPopover } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { chevronDownOutline, chevronUpOutline } from 'ionicons/icons';
import { v4 as uuidv4 } from 'uuid';
import { PopoverOption } from '@core/models/popover.model';

@Component({
  selector: 'app-popover-dropdown',
  templateUrl: './popover-dropdown.component.html',
  styleUrls: ['./popover-dropdown.component.scss'],
  standalone: true,
  imports: [IonButton, IonIcon, IonPopover],
})
export class PopoverDropdownComponent {
  options = input.required<PopoverOption[]>();
  selectedValue = input<string>('');
  tight = input<boolean>(false);
  selectionChange = output<string>();

  @ViewChild('popover') popover!: IonPopover;

  readonly triggerId = `popover-trigger-${uuidv4()}`;
  currentSelection = signal<string>('');
  isPopoverOpen = signal<boolean>(false);

  constructor() {
    addIcons({ chevronDownOutline, chevronUpOutline });

    // Update current selection when selectedValue input changes
    effect(() => {
      const newValue = this.selectedValue();
      if (newValue !== this.currentSelection()) {
        this.currentSelection.set(newValue);
      }
    });
  }

  onSelectOption(value: string): void {
    this.currentSelection.set(value);
    this.selectionChange.emit(value);
    this.popover.dismiss();
  }

  onPopoverDidPresent(): void {
    this.isPopoverOpen.set(true);
  }

  onPopoverDidDismiss(): void {
    this.isPopoverOpen.set(false);
  }

  getSelectedLabel(): string {
    const selected = this.options().find(
      opt => opt.value === this.currentSelection()
    );
    return selected ? selected.label : '';
  }

  isSelected(value: string): boolean {
    return this.currentSelection() === value;
  }
}
